import { get, post } from "services/network/endpoint"
import * as ActionTypes from "services/state/action-types"
import { BFF } from "services/network/routes"
import { dispatchHandler } from "services/utils/action"

export function listInvoiceRecharges(
  { invoiceNumber, year, month, type },
  callback,
  callbackFail
) {
  return (dispatch) => {
    const params = new URLSearchParams()

    params.append("year", year)
    params.append("month", month)

    if (Array.isArray(type)) {
      type.forEach((t) => {
        params.append("type", t)
      })
    }

    const config = {
      pathValues: { invoiceNumber },
      params,
      client: BFF
    }

    const request = get("listInvoiceRecharges", config)

    dispatch({
      type: ActionTypes.LIST_INVOICE_RECHARGES,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function downloadInvoiceRecharge({ id, type }, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { id },
      params: { type },
      client: BFF,
      responseType: "arraybuffer"
    }

    const request = post("downloadInvoiceRecharge", config)

    dispatch({
      type: ActionTypes.DOWNLOAD_INVOICE_RECHARGE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function downloadMultipleInvoiceRecharges(
  payload,
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = {
      data: payload,
      client: BFF,
      responseType: "arraybuffer"
    }

    const request = post("downloadMultipleInvoiceRecharges", config)

    dispatch({
      type: ActionTypes.DOWNLOAD_MULTIPLE_INVOICE_RECHARGES,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/invoiceRecharges/action.js